import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { DistributionReasonValueDTO } from './useWithdrawalOptionsQuery';

export enum TaxMode {
  Amount = 'amount',
  Percentage = 'percentage',
}

export enum TaxModeDTO {
  Amount,
  Percentage,
}

export const MapTaxMode = {
  [TaxMode.Amount]: TaxModeDTO.Amount,
  [TaxMode.Percentage]: TaxModeDTO.Percentage,
};

interface TaxWithholding {
  valueType: TaxModeDTO;
  amountToWithhold: number | null;
}

export interface IraDistribution {
  distributionReason: DistributionReasonValueDTO;
  federalTaxWithholding: TaxWithholding | null;
  stateTaxWithholding: TaxWithholding | null;
}

export interface WithdrawParams {
  clientId: string;
  fromManagedAccountId: string;
  toRelationshipId: string;
  amount: number;
  iraDistribution: IraDistribution | null;
}

const withdraw = async (params: WithdrawParams) =>
  authFetch('/Consumer/AchTransfers/Withdraw', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });

export const useWithdrawMutation = () => {
  return useMutation(withdraw);
};
